import { GET_PATIENT_SUCCESS } from "../actions/patientAction"

  const patientRecordReducer = (state = [], { type, data=[] }) => {
  switch (type) {
    case GET_PATIENT_SUCCESS:
      return data
    default:
      return state
  }
}

export default patientRecordReducer